import createCachedSelector from 're-reselect';

import { State } from '../../typings/state';

export const selectCampaignPlaceEditorData = createCachedSelector(
    (state: State, editorId: string) => state.campaignPlaceEditor[editorId],
    editorData => editorData
)((state: State, editorId: string): string => editorId);
